import React, {createContext, useContext} from "react";
import {useLocalStore} from "mobx-react-lite";
import {AppStoreContext, SESSION_STATUS} from "../../components/Mall/AppStore/AppStore";
import localForage from "localforage";

const queryString = require('query-string');

export const ExceedApiContext = createContext();

const API_BASE_ROUTE = process.env.REACT_APP_API_BASE_ROUTE;
// const API_BASE_ROUTE = 'http://localhost:8080'
// const API_BASE_ROUTE = 'https://test.exceed.ai';
// const API_BASE_ROUTE = 'https://prod.exceed.ai'
const BASE_ROUTE = `${API_BASE_ROUTE}/api`;
// const BASE_ROOT_ROUTE = `${API_BASE_ROUTE}`;
export const BASE_CALLBACK_ROUTE = `${BASE_ROUTE}/external/callback`;

export const ExceedApiProvider = ({children}) => {

    const AppStore = useContext(AppStoreContext);

    const callApi = (route, data, options) => {
        let url = new URL(`${BASE_ROUTE}${route}`)

        const optionsToSend = Object.assign({}, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            useQueryParameters: false,
            credentials: 'include'
        }, options);

        if (data) {
            switch (optionsToSend['method']) {
                case 'get': {
                    break;
                }
                case 'post':
                case 'put':
                case 'delete': {
                    optionsToSend['body'] = JSON.stringify(data);
                    break
                }
                default:
                    throw new Error(`Unexpected error: Got data to send while the request method is '${optionsToSend['method']}'`)
            }
        }

        return fetch(url, optionsToSend)
            .then(response => {
                if (response.ok) {
                    return response.json(); //Promise
                } else {
                    if (response.status === 401) {
                        AppStore.setSessionStatus(SESSION_STATUS.UNSET)
                    }
                    return new Promise((resolve, reject) => reject());
                }
            })
    }

    const loadInitialData = async (location = {state: false}, botToSelect, botIdToSelect, loading = true) => {
        if (loading && AppStore.getInitialDataStatus !== SESSION_STATUS.LOADING) {
            AppStore.setInitialDataStatus(SESSION_STATUS.LOADING)
        }

        let selectedBot = null;

        const localForageBot = await localForage.getItem('selectedBot');
        // const activeForLiveChat = await localForage.getItem('activeForLiveChat');

        let leadBots = await store.getLeadBots();
        if (botToSelect) {        // If came from on-boarding - set to new bot according to id
            selectedBot = botToSelect;
        } else if (botIdToSelect) {
            let selectedBotFromId = leadBots.find(x => x.id === botIdToSelect);
            if (selectedBotFromId) {
                selectedBot = selectedBotFromId
            } else {
                selectedBot = leadBots[0];
            }

        } else if (localForageBot) {            // If already set in localForage - set to localForage
            selectedBot = localForageBot
        } else {
            if (!leadBots) {
                leadBots = await store.getLeadBots();
            }

            selectedBot = leadBots[0];
        }
        AppStore.setLeadBots(leadBots);
        // if (activeForLiveChat) {
        //     await this.apiRest.updateSupportStatus(selectedBot.id, activeForLiveChat)
        // }

        const adminDetails = await store.getAdminDetails(selectedBot.id, AppStore.getSessionData.agentId);
        AppStore.setAdminDetails(adminDetails);
        AppStore.setIsMasterAdmin(adminDetails.authorityNames.includes("ROLE_MASTER_ADMIN"));
        AppStore.setIsOwner(adminDetails.authorityNames.includes("ROLE_ADMIN"));
        AppStore.setIsActiveForLiveChat(adminDetails.activeForLiveChat);

        store.getBotAdmins(selectedBot.id).then((allAdmins) => {
            AppStore.setAllAdmins(allAdmins);
        });

        // this.apiRest.listPlaybooksByBot(selectedBot.id, false).then((allPlaybooks) => {
        //     this.setAllPlaybooks(allPlaybooks);
        // });
        //
        // this.apiRest.listPlaybooksByBot(selectedBot.id, true).then((defaultPlaybooks) => {
        //     this.setDefaultPlaybooks(defaultPlaybooks);
        // });
        //
        AppStore.selectBot(selectedBot);
        AppStore.setInitialDataStatus(SESSION_STATUS.LOADED);

    }

    const store = useLocalStore(() => ({
        login(username, password) {
            return callApi('/auth/login', {username, password}, {
                method: 'post'
            })
        },
        validateSession() {
            return callApi(`/auth/validate`, {}, {method: 'get'});
        },
        getLeadBots() {
            return callApi(`/bots/leadBots`, {}, {method: 'get'})
        },
        getAdminDetails(id, adminId) {
            return callApi(`/admins/${adminId}`, {}, {method: 'get'});
        },
        async loadInitialData(location = {state: false}, botToSelect, botIdToSelect, loading = true) {
            await loadInitialData(location, botToSelect, botIdToSelect, loading);
        },
        getBotAdmins(botId) {
            return callApi(`/${botId}/rep/all`, {}, {method: 'get'});
        },
        getWaitingToApprovedMessages(botId, landlordApproval, adminId, forDashboard) {
            let params = queryString.stringify({
                landlordApproval,
                adminId,
                forDashboard
            })
            return callApi(`/${botId}/leadCommunications/out/waiting?${params}`, {}, {method: 'get'});
        },
        getWaitingCommBotId(botId, commId){
            return callApi(`/${botId}/leadCommunications/out/waiting/${commId}/relatedBotId`, {}, {method: 'get'});
        },
        getLeadDetails(botId, userId) {
            return callApi(`/${botId}/users/${userId}`, {}, {method: 'get'})
        },
        getPlaybookTemplates(botId, playbookId, platform) {
            return callApi(`/emailTemplates/${botId}/templates/${playbookId}${platform ? `?platform=${platform}` : ""}`, {}, {method: 'get'});
        },
        approveMessage(messageId, botId, adminId, text, subject, landlordApproved, cc, leadStatus, selectedIntents, statusReason, statusReasonDetails, templateName,
                       templateType, attachments, templateId, editDetails, clearLeadHold, leadHoldInfo, sendingOption) {
            return callApi(`/${botId}/leadCommunications/out/${messageId}/approve/${adminId}`, {
                text,
                subject,
                landlordApproved,
                cc,
                leadStatus,
                selectedIntents,
                statusReason,
                statusReasonDetails,
                templateName,
                templateType,
                attachments,
                templateId,
                editDetails,
                clearLeadHold,
                leadHoldInfo,
                sendingOption
            }, {method: 'post'});
        },
        ssoLogin(provider, tokenWrapper){
          return callApi(`/auth/mobileSsoLogin/${provider}`, tokenWrapper, {method: 'post'});
        },
        getLeadAdditionalInfo(botId, userId, playbookId) {
            return callApi(`/${botId}/leadCommunications/additionalnfo/${userId}${playbookId ? `?playbookId=${playbookId}` : ""}`, {}, {method: 'get'})
        }
    }));

    return (
        <ExceedApiContext.Provider value={store}>{children}</ExceedApiContext.Provider>
    );
};



